import React, { useEffect, useState, useCallback } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
  onlyNumber,
} from "../../CommonMethhods/CommonMethods";
import searchIcon from "../../asset/images/search-icon.svg";
import SmallLoader from "../../Components/Common/smallLoader";
import downloadbrokrage from "../../asset/images/download-brokrage.svg";
import Loader from "../../Components/Common/Loader";
import AttachmentFile from "../../asset/images/uploadColored.svg";
import { CLIENT_FNO } from "../../Configuration/API_URL";
import { useDebounce } from "../../Components/useDebounce";
import disableUpload from "../../asset/images/upload-disable.svg";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import debounce from "lodash.debounce";

export default function LedgerDashboard(props) {
  let gridVal = props.gridVal;
  const [image, setImage] = useState();
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [actionVal, setActionVal] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [searchField, setSearchField] = useState(false);
  const storeToken = localStorage.getItem("ssoToken");
  const [action, setAction] = useState("");
  const projectRole = JSON.parse(localStorage.getItem("project"));
  const value = projectRole.filter((item) => item?.Name === "Cosmos");
  const valueAdmin = value.filter((item) => item.Role.Name === "Admin");
  const getRole = valueAdmin[0]?.Role?.Name;

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ✅ Debounced API call
  const debouncedSearch = useCallback(
    debounce((value) => {
      // Reset page & old data before new search
      props.setPageTable(1);
      props.setGridVal([]);
      props.setScrollLoaderTable(false);
      props.setLoader(true);

      if (value) {
        props.getClientFno("grid", value, -1, -1);
      } else {
        props.getClientFno("grid", "", -1, 1);
      }

      // setTimeout(() => {
      //   props.setLoader(false);
      // }, 1000);
    }, 500),
    []
  );

  // Watch for search input changes
  useEffect(() => {
    debouncedSearch(searchInput);
  }, [searchInput]);

  // Pagination logic
  const totalPages = Math.ceil((gridVal?.length || 0) / rowsPerPage);
  const currentRows = gridVal?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const pageNumbersToShow = 5;
  let startPage = Math.max(currentPage - Math.floor(pageNumbersToShow / 2), 1);
  let endPage = startPage + pageNumbersToShow - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - pageNumbersToShow + 1, 1);
  }

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (props.count !== gridVal.length) {
        props.setPageTable((prev) => prev + 1);
        props.setScrollLoaderTable(true);
        // props.setLoader(false);
        let offset = props.pageTable + 1;
        props.getClientFno("grid", searchInput, 5, offset);
      } else {
        props.setScrollLoaderTable(false);
      }
    }
  };


const handleSearchInputChange = (val) => {
  const value = val?.toUpperCase();
  setSearchInput(value);
  setSearchField(true);

  // Reset pagination immediately
  setCurrentPage(1); // ✅ reset to first page

  // Call debounced API
  debouncedSearch(value);
};


  return (
    <div className="personal-page brokerage">
      <div className="personal-wrapper">
        <div className="search-input-wrapper">
          <div className="table-top-nav mr-4">
            <div className="rm-custom-dropdown">
              <img src={searchIcon} alt="search" />
              <input
                type="text"
                name="search-text"
                className="input-st ap"
                maxLength={20}
                value={searchInput}
                placeholder="Search by SAP code"
                autoComplete="off"
                onChange={(e) => {
                  const val = e?.target?.value?.toUpperCase();
                  // ❌ Prevent leading space
                  if (val.startsWith(" ")) return;
                  setSearchInput(val);
                  setSearchField(true);
                  handleSearchInputChange(e.target.value);
                  // handleSearchChange(val); // 🔥 call immediately
                }}
                onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;

                  let input = e.target.value.toUpperCase();
                  input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                          input = input.replace(/\s{2,}/g, " "); 
                          input = input.replace(/^\s+/, ""); 

                  if (input.length > 20) input = input.slice(0, 20);
                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
              />
            </div>
          </div>
          <div className="table-top-nav mr-4">
            <div className="table-dt-btn">
              <button
                value="excel"
                onClick={() => {
                  props.getClientFno("excel", searchInput, -1, -1);
                }}
                className="generate-button excel-btn"
              >
                {props.smallLoaderExcel ? (
                  <div>
                    <SmallLoader />
                  </div>
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    {"Excel"}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="brokerage-table">
        {props.loader ? (
          <Loader />
        ) : (
          <div
            className="scroll-table master_table personalised-table general-table"
            onScroll={handleScroll}
            
          >
            {gridVal && gridVal.length > 0 ? (
              <>
              <div className="mt-5 ipo-table-container">
                <table className="table" style={{ width: "135%" }}>
                  <thead style={{ width: "99.95%" }}>
                    <tr>
                      {[
                        "Sr. No",
                        "Account",
                        "Reference",
                        "Document Number",
                        "Document Type",
                        "Document Date",
                        "Posting Date",
                        "Special GLInd",
                        "Posting Key",
                        "Amount in Local Currency",
                        "Text",
                        "Payment Reference",
                        "Assignment",
                        "Clearing Document",
                        "Fin Year",
                      ].map((header, idx) => (
                        <th key={idx}>
                          <span className="wrap-th">
                            <span>{header}</span>
                          </span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody id="per-table-body" style={{ height: "215px" }}>
                    {currentRows.map((item, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{item?.account}</td>
                        <td>{item?.reference}</td>
                        <td>{item?.documentNumber}</td>
                        <td>{item?.documentType}</td>
                        <td>{item?.documentDate?.split(" ")[0]}</td>
                        <td>{item?.postingDate?.split(" ")[0]}</td>
                        <td>{item?.specialGLInd}</td>
                        <td>{item?.postingKey}</td>
                        <td>{item?.amountinLocalCurrency}</td>
                        <td>{item?.text}</td>
                        <td>{item?.paymentReference}</td>
                        <td>{item?.assignment}</td>
                        <td>{item?.clearingDocument}</td>
                        <td>{item?.finYear}</td>
                      </tr>
                    ))}
                    {props.scrollLoaderTable && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </tbody>
                </table>
</div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <label style={{ fontSize: "14px", fontWeight: 500 }}>
                      Items per page:{" "}
                      <select
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                          style={{
                            padding: "0px 10px",
                            fontSize: "14px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            marginLeft: "5px",
                            width: "100px",
                            height: "22px",
                          }}
                      >
                        {[5, 10, 15, 20, 50].map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage === 1}
                      style={buttonStyle}
                    >
                      {"<<"}
                    </button>
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      style={buttonStyle}
                    >
                      {"<"}
                    </button>

                    {Array.from({ length: endPage - startPage + 1 }, (_, idx) => {
                      const pageNum = startPage + idx;
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setCurrentPage(pageNum)}
                          style={{
                            ...pageNumberStyle,
                            backgroundColor:
                              currentPage === pageNum ? "#007bff" : "#fff",
                            color: currentPage === pageNum ? "#fff" : "#333",
                            border:
                              currentPage === pageNum
                                ? "2px solid #007bff"
                                : "1px solid #ccc",
                          }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}

                    <button
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                      style={buttonStyle}
                    >
                      {">"}
                    </button>
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage === totalPages}
                      style={buttonStyle}
                    >
                      {">>"}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              noDataFound()
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// // ✅ Pagination button styles
// const buttonStyle = {
//   padding: "6px 10px",
//   fontSize: "16px",
//   cursor: "pointer",
//   border: "1px solid #ccc",
//   borderRadius: "4px",
//   backgroundColor: "#fff",
//   transition: "all 0.2s",
// };

// const pageNumberStyle = {
//   width: "38px",
//   height: "38px",
//   fontSize: "16px",
//   fontWeight: 600,
//   textAlign: "center",
//   lineHeight: "38px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   transition: "all 0.3s ease",
// };





// ✅ Updated Pagination button styles
const buttonStyle = {
  width: "40px",
  height: "22px",
  fontSize: "12px",
  cursor: "pointer",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0", // removed extra padding to fit 22px
  transition: "all 0.2s",
};

const pageNumberStyle = {
  width: "40px",
  height: "22px",
  fontSize: "12px",
  fontWeight: 600,
  textAlign: "center",
  lineHeight: "22px",
  borderRadius: "4px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
